import { X } from "lucide-react";
import React from "react";

const ConfirmationDialogBox = ({
  loadingStatusUpdate,
  handleCancel,
  handleConfirm,
  message,
  type,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="relative bg-white px-4 py-4 rounded-3xl w-full max-w-xs md:w-[500px] md:max-w-[500px]">
        {/* Close button positioned outside the box */}
        <button
          onClick={handleCancel}
          className="absolute -top-5 -right-10 p-2 bg-white rounded-full hidden md:block"
        >
          <X size={20} />
        </button>

        <div className="align-middle">
          <h3 className="md:text-xl text-base font-bold mb-4 text-text1 text-center">
            Are you sure?
          </h3>
          <hr />
        </div>

        <div className="pt-6 text-[#4B5563]">
          <p
            className="md:text-base text-xs"
            dangerouslySetInnerHTML={{
              __html: message,
            }}
          />
        </div>

        <div className="flex justify-end gap-2 mt-8">
          <button
            onClick={handleCancel}
            className="border-[#D1D5DB] px-4 py-3 rounded-md text-text1 border md:text-sm text-xs"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className={`px-4 py-2 rounded-md md:text-sm text-xs ${
              type === "activate"
                ? "bg-primary text-black"
                : "bg-[#EF4444] text-white"
            }`}
            disabled={loadingStatusUpdate}
          >
            {loadingStatusUpdate ? "Updating..." : type === "terminate" ? "Confirm & Delete" : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialogBox;
